module.exports = __webpack_public_path__ + "static/media/location.63f002ad.svg";